import { LightBoxElement } from '../../objects/light-box';

const SELECTOR_REVIEWS_CONTAINER = '[data-featured-reviews]';
const SELECTOR_BUTTON = '[data-reviews-popup-button]';
const SELECTOR_LIGHTBOX = '[data-reviews-popup-box]';
const SELECTOR_CLOSE = '[data-popup-close]';

document
  .querySelectorAll<HTMLDivElement>(SELECTOR_REVIEWS_CONTAINER)
  .forEach((container) => {
    const lightBox =
      container.querySelector<LightBoxElement>(SELECTOR_LIGHTBOX);
    const openLightbox = container.querySelector<HTMLElement>(SELECTOR_BUTTON);
    const closeButton = container.querySelector<HTMLElement>(SELECTOR_CLOSE);

    if (!lightBox || !openLightbox || !closeButton) return;

    openLightbox.addEventListener('click', openModal);
    closeButton.addEventListener('click', closeModal);
    function openModal() {
      if (!lightBox) return;
      lightBox.visible = true;
    }

    function closeModal() {
      if (!lightBox) return;
      lightBox.visible = false;
    }
  });
